const studentPayResult = {
  path: 'studentPayResult',
  component: resolve => require(['../../../../components/pages/signUp/studentPayResult'], resolve)
}
export default studentPayResult



// WEBPACK FOOTER //
// ./src/router/pages/signUp/studentPayResult/index.js